import React from "react";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="siteFooter">
      <div className="siteFooter__inner">
        <div className="siteFooter__left">
          <div className="siteFooter__brand">The Axis</div>
          <div className="siteFooter__muted">Social platform • Posts • DMs • Updates</div>
        </div>
        <div className="siteFooter__right">
          <a className="siteFooter__link" href="/contact">Contact</a>
          <a className="siteFooter__link" href="/book">Book</a>
          <a className="siteFooter__link" href="/app">App</a>
          <a className="siteFooter__link" href="/blog">Blog</a>
        </div>
      </div>
    </footer>
  );
}
